export const PROVIDERS = {
    default: 1,
    das: 2,
    club: 3,
    shitcoins: 4,
    ee: 5,
};
export function getProviderIdUseCase({ deviceInfo, forceProvider, }) {
    if (forceProvider && forceProvider !== PROVIDERS.default)
        return forceProvider;
    if (!deviceInfo)
        return PROVIDERS.default;
    const { providerName } = deviceInfo;
    const maybeProvider = providerName && PROVIDERS[providerName];
    if (maybeProvider)
        return maybeProvider;
    return 1;
}
//# sourceMappingURL=getProviderIdUseCase.js.map